import { render, staticRenderFns } from "./annualTarget.vue?vue&type=template&id=6984d5cf&scoped=true"
import script from "./annualTarget.vue?vue&type=script&lang=js"
export * from "./annualTarget.vue?vue&type=script&lang=js"
import style0 from "./annualTarget.vue?vue&type=style&index=0&id=6984d5cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6984d5cf",
  null
  
)

export default component.exports